export const data = [
	{
		key: '1',
		item: 'Egg Chowmin',
		price: '₹ 16',
		quantity: '1',
		total: '₹ 16',
		remove: '1'
	},
	{
		key: '2',
		item: 'Chicken Momo',
		price: '₹ 20',
		quantity: '2',
		total: '₹ 40',
		remove: '2'
	},
	{
		key: '3',
		item: 'Sadheko Peanut',
		price: '₹ 8',
		quantity: '4',
		total: '₹ 32',
		remove: '3'
	},
	{
		key: '4',
		item: 'Chicken Stick',
		price: '₹ 8',
		quantity: '1',
		total: '₹ 8',
		remove: '4'
	}
];
